function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import qs from 'qs';
import RightToPracticeCard from './RightToPracticeCard.vue';
export default {
  data: function data() {
    return {
      searchQuery: '',
      includeExMember: false,
      errors: '',
      membersFound: '',
      membersFoundLength: 0,
      isLoading: false
    };
  },
  components: {
    RightToPracticeCard: RightToPracticeCard
  },
  mounted: function mounted() {
    var searchParams = new URLSearchParams(window.location.search);

    if (_toConsumableArray(searchParams).length > 0) {
      this.searchQuery = searchParams.get('search_query');
      this.includeExMember = searchParams.get('include_ex_member') == 'true';
      this.checkRightToPractice();
    }
  },
  methods: {
    checkRightToPractice: function checkRightToPractice() {
      var _this = this;

      this.isLoading = true;
      var data = {
        action: 'check_right_to_practice',
        search_query: this.searchQuery,
        include_ex_member: this.includeExMember
      };
      var options = {
        method: 'POST',
        headers: {
          'content-type': 'application/x-www-form-urlencoded'
        },
        body: qs.stringify(data)
      };
      window.history.pushState({}, null, window.location.pathname + '?' + qs.stringify(data));
      fetch(tolle_ajax_params.admin_url, options).then(function (res) {
        return res.json();
      }).then(function () {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : json,
            success = _ref.success,
            data = _ref.data;

        if (success) {
          _this.membersFound = data;
          _this.membersFoundLength = Object.keys(_this.membersFound).length;
        } else {
          _this.errors = data;
        }
      }).catch(function (err) {
        return console.log(err);
      }).finally(function () {
        return _this.isLoading = false;
      });
    },
    clearErrors: function clearErrors() {
      this.errors = '';
    },
    clearSearchQuery: function clearSearchQuery() {
      this.searchQuery = '';
    }
  }
};